





















import Vue from 'vue'
import moment from 'moment/moment'
import { Icon, Toast } from 'vant';
import SelfStationDataGetter from '@/service/SelfStationDataGetter';
import chartEle from './chart_ele.vue'

export default Vue.extend({
  props: {
    stationId: { type: String }
  },
  components: {
    chartEle
  },

  watch: {
    stationId() {
      this.getData()
    },
    element() {
      this.getData()
    }
  },
  data() {
    return {
      element: 'tem',
      data: undefined,
    }
  },
  created() {
  },
  methods: {
    getData() {
      const timeFormater = 'YYYYMMDDHH0000'
      const beginTime = moment().subtract(24, 'hour').format(timeFormater)
      const endTime = moment().format(timeFormater)
      SelfStationDataGetter.getSelfStationData('surf_hour_data', 'station_id_c,tem,rhu,lst,irr,irr_max', this.stationId, beginTime, endTime).then((res: any) => {
        console.log(res)
        if (res && res.length > 0) {
          this.data = res
          console.log(this.data)
        }
      })
    }
    // getData() {
    //   adminService.getGrowthPeriod(this.type).then((res: any) => {
    //     if (res && res.growType) {
    //       this.growPeriod = res
    //       adminService.getGrowthSystem(res.growType).then((res1: any) => {
    //         if (res1) {
    //           this.data = res1
    //         }
    //       })
    //     }



    //   })
    // }

  },
  filters: {
    dtFormat(datetime: number) {
      const time = moment(datetime, 'YYYYMMDDHHmmss')
      return time.add(8, 'hours').format('YYYY年M月D日HH时mm分')
    }
  }
})
